<template>
  <aside class="faq-travelers-page__menu">
    <nav
      class="faq-travelers-page__menu-nav"
      aria-label="Навигация для путешественников"
    >
      <div class="faq-travelers-page__menu-nav-title">Помощь путешественникам</div>
      <ul class="faq-travelers-page__menu-nav-list">
        <li
          v-for="item in TRAVELERS_MENU_ITEMS"
          :key="item.label"
          class="faq-travelers-page__menu-nav-item"
        >
          <RouterLink
            v-if="!item.link"
            :to="{ name: 'travelers-faq' }"
            :class="[
              'faq-travelers-page__menu-nav-link',
              { 'faq-travelers-page__menu-nav-link--active': route.name === 'travelers-faq' },
            ]"
          >
            {{ item.label }}
          </RouterLink>
          <a
            v-else
            :href="item.link"
            class="faq-travelers-page__menu-nav-link"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script setup lang="ts">
  import { TRAVELERS_MENU_ITEMS } from './menuItems';

  const route = useRoute();
</script>

<style lang="scss" scoped>
  .faq-travelers-page__menu-nav-title {
    color: var(--alias-color-text-default);

    @include typography.base-400-400-semi;
  }

  .faq-travelers-page__menu-nav-list {
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-24);
    padding: 0;
    list-style-type: none;
  }

  .faq-travelers-page__menu-nav-item {
    margin: 0;
  }

  .faq-travelers-page__menu-nav-link {
    display: inline-flex;
    width: 100%;
    text-decoration: none;

    @include typography.base-400-400-regular;
  }

  .faq-travelers-page__menu-nav-link:hover {
    color: var(--alias-color-text-default);
  }

  .faq-travelers-page__menu-nav-link--active {
    padding: var(--alias-space-4) var(--alias-space-8);
    border-radius: var(--alias-radius-8);
    background-color: var(--alias-color-background-subtle);
    transform: translateX(calc(var(--alias-space-8) * -1));
  }
</style>
